

import { Button, Modal, ModalBody} from 'reactstrap';
import React, {Component} from 'react';
import LoadingComponent from '../../../../components/loading/LoadingComponent'

const translator = require('../../../../utils/translator/translator');

class PaymentDialogueStatusView extends Component 
{
    onClose = () =>
    {
        this.props.onClose();

        
    }

    constructor(props) 
    {
        super(props);

        this.state = {};
        this.state.cancellationInProgress = false;
    }

    renderErrorView = ()=>
    {
        return(

            
            <Modal isOpen={true} centered className="animated fadeIn">
                  <ModalBody style={{marginTop:'20px', marginBottom:'20px'}}>
                      <table width="100%" height="100%">
                          <tr align="middle">
                                <img src="./images/error.png" width="50px" height="50px" style={{marginBottom:'10px'}}/> 
                          </tr>
                          <tr align="middle" style={{fontSize:'1.3rem', color:'#585858'}}>
                            {this.props.errorMessage}
                          </tr>

                          <tr align="middle">
                            <Button color="secondary" style={{width:'50%', height:'100%', fontWeight:'bold', fontSize:'1.3rem', marginTop: '10px'}} onClick={()=>{this.props.onErrorClose()}}>{translator.getLabel("ok")}</Button>
                          </tr>
                      </table>
                    
                  </ModalBody>
            </Modal>);
    }


    renderStatusView = ()=>
    {
        var statusMessage = this.props.statusMessage;
        var cancelButton = null;
        if (this.props.onCancelTransaction != null)
        {
            var cancelButtonDisabled = false;
            if (this.state.cancellationInProgress)
            {
                cancelButtonDisabled = true;
                statusMessage = translator.getLabel("cancelling_transaction");
            }

            cancelButton = <Button color="danger" disabled={cancelButtonDisabled} style={{width:'60%', height:'100%', fontWeight:'bold', fontSize:'1.3rem', marginTop: '20px'}}
                                    onClick={()=>
                                    {
                                        this.state.cancellationInProgress = true;
                                        this.setState({});
                                        this.props.onCancelTransaction();
                                    }}>
                               {translator.getLabel("cancel")}
                            </Button>
        }
        return(
            <Modal isOpen={true} centered className="animated fadeIn">
                  <ModalBody style={{marginTop:'20px', marginBottom:'20px'}}>
                      <table width="100%" height="100%">
                          <tr>
                            <td>
                                <LoadingComponent waitMessage={statusMessage}/>
                            </td>
                          </tr>
                          
                          <tr align="middle">
                            <td>
                                {cancelButton}
                            </td>
                          </tr>
                      </table>
                    
                  </ModalBody>
            </Modal>);
    }

    renderSuccessView = ()=>
    {
        return(

            
            <Modal isOpen={true} centered className="animated fadeIn">
                  <ModalBody style={{marginTop:'20px', marginBottom:'20px'}}>
                      <table width="100%" height="100%">

                          <tr align="middle">
                            <Button color="success" style={{width:'100%', height:'100px', fontWeight:'bold', fontSize:'1.3rem'}} onClick={()=>{this.props.onSuccessClose()}}>{translator.getLabel("payment_authorized")}</Button>
                          </tr>
                      </table>
                    
                  </ModalBody>
            </Modal>);
    }

    renderDeclineView = ()=>
    {
        return(

            
            <Modal isOpen={true} centered className="animated fadeIn">
                  <ModalBody style={{marginTop:'20px', marginBottom:'20px'}}>
                      <table width="100%" height="100%">

                          <tr align="middle">
                            <Button color="danger" style={{width:'100%', height:'100px', fontWeight:'bold', fontSize:'1.3rem'}} onClick={()=>{this.props.onDeclineClose()}}>{translator.getLabel("payment_declined")}</Button>
                          </tr>
                      </table>
                    
                  </ModalBody>
            </Modal>);
    }

    renderSignatureVerification = ()=>
    {
        return(
            <Modal isOpen={true} centered className="animated fadeIn">
                  <ModalBody style={{marginTop:'20px', marginBottom:'20px'}}>
                      <table width="100%" height="100%">
                          <tr align="middle" style={{fontSize:'25px'}}>
                              <div style={{marginBottom:'10px'}}>
                              {translator.getLabel("please_verify_customer_signature")}
                              </div>
                                
                          </tr>
                          <tr align="right">
                            <table width="100%">
                                <tr align="middle">
                                    <td width="50%">
                                        <Button color="success" style={{width:'98%', height:'100%', fontWeight:'bold', fontSize:'1.3rem'}} onClick={()=>{this.props.onCardVerified()}}>{translator.getLabel("verified")}</Button>
                                    </td>

                                    <td width="50%">
                                        <Button color="danger" style={{width:'98%', height:'100%', fontWeight:'bold', fontSize:'1.3rem'}} onClick={()=>{this.props.onCardNotVerified()}}>{translator.getLabel("not_verified")}</Button>
                                    </td>
                                </tr>
                            </table>
                           
                          </tr>
                      </table>
                    
                  </ModalBody>
            </Modal>);
    }

    render() 
    {
        if (this.props.displayType == "error")
            return this.renderErrorView();

        if (this.props.displayType == "status")
            return this.renderStatusView();

        if (this.props.displayType == "success")
            return this.renderSuccessView();
        
        if (this.props.displayType == "decline")
            return this.renderDeclineView();

        if (this.props.displayType == "signature_verification")
            return this.renderSignatureVerification();
    }
}

export default PaymentDialogueStatusView;